import {Parser} from 'htmlparser2';

const isLabel = attributes => {
  const classList = attributes.hasOwnProperty('class') ? attributes.class.split(/\s+/) : [];
  return classList.includes('label');
};

const labelHtml = state => {
  let max, pos = state.pos;

  max = state.posMax;
  if (state.src.slice(pos + 1, pos + 5).toLowerCase() !== 'span') {
    return false;
  }

  let spanLevel = 0;
  const label = {
    start: null,
    end: null,
    color: null,
  };

  const parser = new Parser({
    onopentag(name, attributes, isImplied) {
      if (name === 'span') {
        spanLevel++;
      }

      if (spanLevel === 1 && name === 'span' && isLabel(attributes)) {
        if (!label.start) {
          label.start = {
            startIndex: parser.startIndex,
            endIndex: parser.endIndex,
          };
          label.color = attributes['data-color']
        }
      }
    },
    onclosetag(name, isImplied) {
      if (name === 'span') {
        spanLevel--;
      }

      if (spanLevel === 0 && name === 'span') {
        if (!label.end) {
          label.end = {
            startIndex: parser.startIndex,
            endIndex: parser.endIndex,
          };
        }
      }
    },
  });

  parser.write(state.src.slice(pos));

  if ((!label.start || label.start.startIndex > 0) || !label.end) {
    return false;
  }

  const token = state.push('label_open', 'span', 1);
  if (label.color) {
    token.attrs = [['data-color', label.color]];
  }

  state.pos = pos + label.start.endIndex + 1;
  state.posMax = pos + label.end.startIndex;

  state.linkLevel++;
  state.md.inline.tokenize(state);
  state.linkLevel--;

  state.push('label_close', 'span', -1);

  state.pos = pos + label.end.endIndex + 1;
  state.posMax = max;

  return true;
};

export const markdownLabel = md => md.inline.ruler.after('html_inline',
    'label', labelHtml);